<template lang="pug">
  div
    Section1Widget(to="/")
    b-spinner(v-if="!$root.employees" variant="secondary")
    b-card
      b-card-title {{dict.title}}
      b-card-text.text-left {{dict.verbiage}}
      b-card-text(v-if="$root.employees")
        b-row
          b-col(cols="6" v-for="employee in $root.employees" :key="employee.id")
            b-link(:to="'/team/'+employee.id")
              b-img(:src="assets_base_url + employee.image_url" fluid)
            h5 {{$root.lang==='zh' ? employee.name_zh : employee.name_en }} - {{$root.lang==='zh' ? employee.title_zh : employee.title_en}}
    
</template>
<script>
import ApiHandlingMixin from './common/ApiHandlingMixin'
import Section1Widget from './components/Section1Widget.vue'
import Employee from './Employee.vue'

export default {
  name: 'Team',

  mixins: [ApiHandlingMixin],

  components: {
    Section1Widget,
    Employee
  },

  data: function(){
    return {
      dict: this.$dictionary.team,
      assets_base_url: process.env.VUE_APP_ASSETS_URL,
    }
  },

  computed: {
  },

  methods: {
  
  }
}
</script>
